// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/stylus/components/_chips.styl
// module id = 102
// module chunks = 0